import { i18n } from '@/locales';
const { t } = i18n;
const lc = 'views.worker_management.';
const orderDelayTimeSecondNumber = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    20,
    30,
    40,
    50,
    60,
    70,
    80,
    90,
    100,
    300,
    600,
];
const result = {};
orderDelayTimeSecondNumber.forEach((code, index) => {
    result[code] = {
        text: t(`${lc}order_delay_time_second_code_text[${index}]`),
        value: code,
    };
});
export default result;
